import Typography from "@@/elements/Typography";
import { PrimaryButtonProps } from "./buttonProps";
import styles from "./buttonStyles.module.scss";
import { formatLinkContent } from "./utils";

const PrimaryButton = ({
  disabled,
  onClick,
  label,
  title,
  href,
  target = "_self",
  externalLinkText,
}: PrimaryButtonProps) => {
  if (href) {
    return (
      <a
        title={title}
        href={href}
        className={`${styles.base_button} ${styles.primary}`}
        target={target}
      >
          {formatLinkContent(href, label, target, externalLinkText, "light")}
      </a>
    );
  }
  return (
    <button
      type="button"
      title={title}
      disabled={disabled}
      onClick={onClick}
      className={`${styles.base_button} ${styles.primary}`}
    >
      <Typography textcolor="light" variant="button" asElement="span">
        {label}
      </Typography>
    </button>
  );
};
export default PrimaryButton;
